import {useState,createContext} from 'react';
import { TopDisplay} from '../../../ui-components';
import css from '../Approvals/css/approvals.module.css';
import Modal from '../Approvals/Modal'; 
import {  } from '../Approvals/Approve/Approvals';
import { useSelector } from 'react-redux';
import {RootState} from '../../../redux/store';
import {DisplayAppplications} from '../Applications';

export const ApplicationsContext = createContext<any>({});


function Applications() {  
    const[showModal ,setShowModal] = useState<boolean>(false);
    const [modalView,setModalView] = useState<any>('view');
    const [modalData,setModalData] = useState<any>(null);
    const [routeName, setRouteName] = useState('Examination / NYSC');
    const isApplicationMenu = true
    const ApplicationsContextProvider = {
        setShowModal,
        setModalView,
        setModalData,
        setRouteName,
        routeName,
        isApplicationMenu
    };

    const applicantId  = useSelector((state: RootState) =>state?.applicantId?.applicantId );


   
  return (
    <>
        <ApplicationsContext.Provider value={ApplicationsContextProvider}>
            <div className={css.container}>
                <TopDisplay
                title="Applications" />
                <DisplayAppplications />
            </div>
            <Modal showModal={showModal} setShowModal={setShowModal} modalView={modalView} data={modalData}  />  
        </ApplicationsContext.Provider>
    </>
  )
 }
 

export default Applications;

